import Nav from './partials/Nav.js'
import PopinMedoc from './partials/PopinMedoc.js'
import PopinPlayer from './partials/PopinPlayer.js'
import ScrollParallax from './libs/ScrollParallax';
import KeyNumber from './libs/KeyNumber.js';
import Slider from './components/Slider.js';

import "whatwg-fetch";
import "babel-polyfill";
import "dom-shims";
import 'better-dom/dist/better-dom.js';
import 'better-dateinput-polyfill/dist/better-dateinput-polyfill.js';
 
class App
{
  constructor()
  {
    // console.log( 'App' )
  } 

  init()
  {
    this.nav = new Nav()
    this.popin = new PopinPlayer()
    this.popinMedoc = new PopinMedoc()

    ScrollParallax.init()
    ScrollParallax.instance.active()
    
    let articles = document.body.querySelectorAll('.Article')

    for (let i = 0; i < articles.length; i++) {
      let article = articles[i];

      ScrollParallax.set(article, { opacity: 1, y:0 }, { opacity: 0.3, y:30 }, { opacity: 1, y:0 });
      ScrollParallax.set(article.querySelector('.Article_key-number_picture'), { y: 0, rotate:0 }, { y: 30, rotate:15 }, { y: 0, rotate:0 });
    }

    let imagesRight = document.body.querySelectorAll('.Section_contenu-image img')

    for (let i = 0; i < imagesRight.length; i++) {
      let img = imagesRight[i];

      ScrollParallax.set(img, { x:0 }, { x:"50%" }, { x:0 });
    }
    
    if(document.body.querySelector('.Section_slider'))
      this.slider = new Slider(document.body.querySelector('.Section_slider'))

    let keyNumbers = document.body.querySelectorAll('.Article_key-number')
    this.keyNumbers = []
    for (let i = 0; i < keyNumbers.length; i++) {
      this.keyNumbers.push(new KeyNumber(keyNumbers[i]));
    }

    document.addEventListener("DOMContentLoaded", this.display.bind(this) )
    window.addEventListener("resize", this._onResize.bind(this) )

    this._onResize()

    if(document.body.querySelector('.ScrollTop'))
      document.body.querySelector('.ScrollTop').addEventListener("click", this._scrollTop.bind(this) )

    if(document.body.classList.contains('contact'))
      this._formInject()
      
    if(document.body.querySelector('.Section_close'))
    {
      document.body.querySelector('.Section_close').addEventListener('click', this._goBack.bind(this))
    }

    if(document.body.querySelector('.Button_Login'))
    {
      document.body.querySelector('.Button_Login').addEventListener( 'click', () =>
      {
        this.nav.openAccountPanel();
      });
    }

    if(document.body.querySelector('.Table_header'))
    {
      const th = document.body.querySelectorAll('.Medicaments_table .Table_header th[data-id]')
      for (let i = 0; i < th.length; i++) {
        th[i].querySelector('.fas').addEventListener( 'click', this.selectSort.bind( this ))
        th[i].querySelector('.fas').classList.add('fa-sort-down')
      }

      const filters = document.body.querySelectorAll('select.filter-catalogue')
      for (let i = 0; i < filters.length; i++) {
        filters[i].addEventListener( 'change', this.filter.bind( this ))
      }
    }

    if(document.body.querySelector('.form-search'))
    {
      document.body.querySelector('.form-search .search-value').addEventListener( 'keyup', this.search.bind( this ) );
    }
    
    if(document.body.querySelector('#member'))
    {
      for (let index = 0; index < document.body.querySelectorAll('#member input').length; index++) {
        let el = document.body.querySelectorAll('#member input')[index];
        el.addEventListener( 'click', (e) => {
          if(e.currentTarget.id === "member1")
          {
            document.body.querySelector('#groupment_container').style.display = "block"
            document.body.querySelector('#groupment').required = true
            // document.body.querySelector('#groupment_since').required = true
          }else
          {
            document.body.querySelector('#groupment_container').style.display = "none"
            document.body.querySelector('#groupment').required = false
            // document.body.querySelector('#groupment_since').required = false
          }
        });
      }
    }


  }

  selectSort( e )
  { 
    const sortId = e.target.parentNode.dataset.id;
    
    let items = Array.prototype.slice.call(document.body.querySelectorAll('.Medicaments_table tbody > tr'), 0)
    items.sort( function( a, b )
    {
      const aV = JSON.parse( a.dataset.medoc )['sortId']
      const bV = JSON.parse( b.dataset.medoc )['sortId']
      return aV > bV ? 1 : -1
    })

    const th = document.body.querySelectorAll('.Medicaments_table .Table_header th[data-id]')
    for (let i = 0; i < th.length; i++) {
      if( th[i].querySelector('.fas') != e.target )
      {
        th[i].querySelector('.fas').classList.remove('fa-sort-up')
        th[i].querySelector('.fas').classList.add('fa-sort-down')
      }
    }

    let fas = e.target

    if( fas.classList.contains('fa-sort-down') )
    {
      fas.classList.remove('fa-sort-down')
      fas.classList.add('fa-sort-up')
    }
    else
    {
      fas.classList.add('fa-sort-down')
      fas.classList.remove('fa-sort-up')
    }

    const tbody = document.body.querySelector('.Medicaments_table tbody')
    tbody.innerHTML = ''
    for (let i = 0; i < items.length; i++) {
      tbody.appendChild( items[i] )
    }
  }

  filter( e )
  {
    const v = e.target.value.toLowerCase()

    let n = 0;
    const items = document.body.querySelectorAll('.Medicaments_table tbody > tr')
    for (let i = 0; i < items.length; i++) {
      let d = JSON.parse( items[i].dataset.medoc )
      if( d['aireTherapeutique'] && d['aireTherapeutique'].toLowerCase().indexOf( v ) > -1 )
      {
        items[i].classList.remove( 'is-inactive')
        n++
      }
      else
      {
        items[i].classList.add( 'is-inactive')  
      }
    }

    document.body.querySelector('.no-result').style.display = n === 0 ? 'block' : 'none'

    document.body.querySelector('.form-search .search-value').value = ''
  }

  search( e )
  {
    const v = document.body.querySelector('.form-search .search-value').value.toLowerCase()

    let n = 0
    const items = document.body.querySelectorAll('.Medicaments_table tbody > tr')
    for (let i = 0; i < items.length; i++) {
      let d = JSON.parse( items[i].dataset.medoc )
      if( ( d['dci'] && d['dci'].toLowerCase().indexOf( v ) > -1 ) || ( d['princeps'] && d['princeps'].toLowerCase().indexOf( v ) > -1 ) || ( d['cip'] && d['cip'].toLowerCase().indexOf( v ) > -1 ) || ( d['aireTherapeutique'] && d['aireTherapeutique'].toLowerCase().indexOf( v ) > -1 ) )
      {
        items[i].classList.remove( 'is-inactive')
        n++
      }
      else
      {
        items[i].classList.add( 'is-inactive')  
      }
    }

    document.body.querySelector('.no-result').style.display = n === 0 ? 'block' : 'none'

    const filters = document.body.querySelectorAll('select.filter-catalogue')
      for (let i = 0; i < filters.length; i++) {
        filters[i].selectedIndex = 0
      }
  }

  _goBack()
  {
    if(history.length > 0) 
    { 
      history.go(-1); 
    }
  }

  _formInject()
  {
    let form = document.body.querySelector('form')
    let user = form.querySelector('[data-user]') ? JSON.parse(form.querySelector('[data-user]').getAttribute('data-user')) : null

    if(user == null) return

    if(user.authorize)
      form.querySelector('[value="professionnel"]').checked = true

    if(user.gender == 1)
      form.querySelector('[value="Mme"]').selected = "selected"

    if(user.lastname)
      form.querySelector('[name="txt_nom"]').value = user.lastname

    if(user.firstname)
      form.querySelector('[name="txt_prenom"]').value = user.firstname

    if(user.workplace)
      form.querySelector('[name="company"]').value = user.workplace

    if(user.email)
      form.querySelector('[name="txt_mail"]').value = user.email

    if(user.address)
      form.querySelector('[name="txt_address"]').value = user.address

    if(user.postalcode)
      form.querySelector('[name="txt_zip"]').value = user.postalcode

    if(user.city)
      form.querySelector('[name="txt_city"]').value = user.city

    if(user.phone)
      form.querySelector('[name="phone"]').value = user.phone
  }

  _onResize()
  {
    let preview = document.body.querySelector('[data-previewmob]')

    if(preview)
    {
      let previewInfos = { mobile: preview.dataset.previewmob, desktop: preview.dataset.previewdesk }
      if(window.innerWidth < 800)
        preview.style.backgroundImage = 'url(' + previewInfos.mobile + ')'
      else
        preview.style.backgroundImage = 'url(' + previewInfos.desktop + ')'
    }
  }

  _scrollTop()
  {
    TweenMax.to(window, 1, { scrollTo: {y:0, autoKill:false}, ease: Power2.easeInOut });
  }

  display()
  {
    document.body.querySelector('#main').style.opacity = 1
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/js/App.js